import type {IconProps} from 'Catalyst/components/Icon';

export const getIcon = (icon: string) => {
  return (icon === 'false' ? '' : icon) as IconProps['name'];
};
